module.exports = __webpack_public_path__ + "static/media/shopping-cart-icon.6308b42d.svg";